import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const BroadcastMetadata = ({ 
  metadata, 
  onMetadataChange, 
  disabled = false 
}) => {
  const categoryOptions = [
    { value: 'music', label: 'Музыка' },
    { value: 'talk', label: 'Разговоры' },
    { value: 'philosophy', label: 'Философия' },
    { value: 'meditation', label: 'Медитация' },
    { value: 'storytelling', label: 'Истории' },
    { value: 'education', label: 'Образование' },
    { value: 'culture', label: 'Культура' },
    { value: 'other', label: 'Другое' }
  ];

  const privacyOptions = [
    { value: 'public', label: 'Публичный' },
    { value: 'unlisted', label: 'По ссылке' },
    { value: 'private', label: 'Приватный' }
  ];

  const handleChange = (field, value) => {
    onMetadataChange({
      ...metadata,
      [field]: value
    });
  };

  return (
    <div className="broadcast-metadata bg-card rounded-lg border border-border p-6 shadow-soft">
      <div className="metadata-header mb-4">
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Настройки трансляции
        </h3>
        <p className="text-sm text-muted-foreground mt-1">
          Заполните информацию о вашем эфире
        </p>
      </div>
      <div className="metadata-form space-y-4">
        <Input
          label="Название эфира"
          type="text"
          placeholder="Введите название вашей трансляции"
          value={metadata?.title || ''}
          onChange={(e) => handleChange('title', e?.target?.value)}
          disabled={disabled}
          required
        />

        <Input
          label="Описание"
          type="text"
          placeholder="Расскажите, о чём будет ваш эфир"
          value={metadata?.description || ''}
          onChange={(e) => handleChange('description', e?.target?.value)}
          disabled={disabled}
        />

        <Select
          label="Категория"
          options={categoryOptions}
          value={metadata?.category || 'talk'}
          onChange={(value) => handleChange('category', value)}
          disabled={disabled}
        />

        <Input
          label="Теги"
          type="text"
          placeholder="философия, медитация, музыка"
          description="Разделяйте теги запятыми"
          value={metadata?.tags || ''}
          onChange={(e) => handleChange('tags', e?.target?.value)}
          disabled={disabled}
        />

        <Select
          label="Приватность"
          options={privacyOptions}
          value={metadata?.privacy || 'public'}
          onChange={(value) => handleChange('privacy', value)}
          disabled={disabled}
        />

        <div className="metadata-options space-y-3 pt-2">
          <Checkbox
            label="Разрешить комментарии"
            checked={metadata?.allowComments || false}
            onChange={(e) => handleChange('allowComments', e?.target?.checked)}
            disabled={disabled}
          />

          <Checkbox
            label="Сохранить запись после эфира"
            checked={metadata?.saveRecording || true}
            onChange={(e) => handleChange('saveRecording', e?.target?.checked)}
            disabled={disabled}
          />

          <Checkbox
            label="Разрешить скачивание"
            checked={metadata?.allowDownload || false}
            onChange={(e) => handleChange('allowDownload', e?.target?.checked)}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default BroadcastMetadata;